import React, { useEffect, useState } from 'react';
import ProjectCardHome from '../../components/Project/ProjectCardHome';

const Project = () => {

    const staticProject = {
        id: 1,
        category: 'Express Logistics',
        content: 'Infrastructure That Inspires Confidence',
    };

    const [apiProjects, setApiProjects] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/api/infrastructure/`)
            .then((res) => res.json())
            .then((data) => {
                setApiProjects(data);
                setIsLoading(false);
            })
            .catch((err) => {
                console.error(err);
                setIsLoading(false);
            });
    }, []);

    if (isLoading) {
        return (
            <div>
                <span className="loading loading-ring loading-xl"></span>
            </div>
        );
    }

    return (
        <section className="project-one">
            <div className="container">
                <div className="row">

                    {/* 🔥 STATIC CARD (NO SLIDER) */}
                    <div className="col-xl-4 col-lg-6 col-md-6">
                        <div className="project-two__single">
                            <div className="project-two__content-box">
                                <div className="text-left section-title">
                                    <div className="section-title__tagline-box">
                                        <span className="section-title__tagline">Latest Project</span>
                                    </div>
                                    <h2 className="section-title__title">
                                        {staticProject.content}
                                    </h2>
                                </div>

                                <div className="project-two__btn-box">
                                    <a href="/infrastructure" className="thm-btn project-two__btn">
                                        View More <span />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 🔥 SLIDER (ONLY API DATA) */}
                    <div className="col-xl-8 col-lg-6 col-md-12">
                        <ProjectCardHome
                            projects={apiProjects.slice(0, 5)}
                            imgStyle={{ width: "600px", height: "310px", objectFit: "cover" }}
                        />
                    </div>

                </div>
            </div>
        </section>
    );
};

export default Project;